namespace Nbs.Xlr8PageTemplate.Favicon {
  const faviconLinkId = 'uxlFaviconLink';

  export function setFavicon(faviconUrl?: string) {
    removeFaviconLink();
    if (faviconUrl) {
      addFaviconLink(faviconUrl);
    }
  }

  function addFaviconLink(url: string) {
    const link = document.createElement('link');

    link.id = faviconLinkId;
    link.href = url;

    if (url.indexOf('.gif') >= 0) {
      link.rel = 'icon';
      link.type = 'image/gif';
    } else if (url.indexOf('.png') >= 0) {
      link.rel = 'icon';
      link.type = 'image/png';
    } else if (url.indexOf('.svg') >= 0) {
      link.rel = 'icon';
      link.type = 'image/svg+xml';
    } else {
      link.rel = 'shortcut icon';
    }

    document.head.appendChild(link);
  }

  function removeFaviconLink() {
    const link = document.getElementById(faviconLinkId);
    if (link) {
      link.remove();
    }
  }
}
